<script setup lang="js">
import Vue3Datatable from "@bhplugin/vue3-datatable";
import {ref} from "vue";
import {useRouter} from "vue-router";
import {useI18n} from "vue-i18n";
import moment from "moment-jalaali";

const {auditLogs, isLoading} = defineProps({auditLogs: {type: Array, required: true}, isLoading: {type: Boolean, default: false}});

const router = useRouter()
const {t: $t} = useI18n()

const cols = [
  {field: "id", title: $t('title.id')},
  {field: "Auditor", title: $t('title.auditor')},
  {field: "eventName", title: $t('title.event-name')},
  {field: "data", title: $t('title.log-data')},
  {field: "createdAt", title: $t('title.created-at')},
]
const pageOptions = ref({
  count: 1,
  limit: 10,
  page: 1
})


function formatData(data) {
  if (!data) return ''
  if (data.old || data.new) {
    return data.old ?
        `${data.old} --> ${data.new}`: data.new
  }
  return ''
}


</script>

<template>
  <vue3-datatable
      :columns="cols"
      :rows="auditLogs"
      :loading="isLoading"
      :totalRows="pageOptions.count"
      :isServerMode="true"
      :pageSize="pageOptions.limit"
      :pagination="false"
      :sortable="false"
      class="advanced-table px-4 text-start items-start justify-start"
      rowClass="cursor-pointer"
  >
    <!-- Empty header slot to remove the header -->
    <template #header>
      <!-- No content here will hide the header -->
    </template>
    <!-- Empty footer slot to remove the footer -->
    <template #footer>
      <!-- No content here will hide the footer -->
    </template>

    <template #id="data,key">
      <div class="text-start">
        {{ data.value.id }}
      </div>
    </template>

    <template #eventName="data,key">
      <div class="text-start">
        {{ $t(`iaas-events.${data.value.eventName}`,1, {default: data.value.eventName}) }}
      </div>
    </template>
    <template #Auditor="data,key">
      <div class="text-start">
        {{ data.value.Auditor.Profile.firstName + ' ' + data.value.Auditor.Profile.lastName }}
      </div>
    </template>
    <template #data="data,key">
      <div class="text-start">
        {{ formatData(data.value.data) }}
      </div>
    </template>

    <template #createdAt="data,key">
      <div class="text-start" >
        {{ data.value.createdAt?moment(data.value.createdAt	).locale("fa").format("jYYYY/jMM/jDD HH:mm"):'-' }}
      </div>
    </template>
  </vue3-datatable>
</template>

<style scoped>

</style>